import masthead from "../assests/HPE/enterpriseone/smb-b/webp/masthead-smb-b.webp";
import zertoMaster from "../assests/HPE/enterpriseone/smb-a/webp/benefits.webp";
import clockIcon from "../assests/HPE/enterpriseone/ent-a/icons/clock.svg";
import arrowRightIcon from "../assests/HPE/enterpriseone/ent-a/icons/arrow-right.svg";
import userIcon from "../assests/HPE/enterpriseone/ent-a/icons/user.svg";
import number1 from "../assests/HPE/enterpriseone/smb-b/numbers-1.svg";
import number2 from "../assests/HPE/enterpriseone/smb-b/numbers-2.svg";
import number3 from "../assests/HPE/enterpriseone/smb-b/numbers-3.svg";
import document1 from "../assests/HPE/enterpriseone/ent-a/webp/zip-documents-1.webp";
import document2 from "../assests/HPE/enterpriseone/ent-a/webp/zip-documents-2.webp";
import document3 from "../assests/HPE/enterpriseone/ent-a/webp/zip-documents-3.webp";
import Input from "../components/common/Input";
import HilightCard from "../components/ui/enterprise1/HilightCard";
import benefitCard1 from "../assests/HPE/enterpriseone/smb-b/benefits-1.svg";
import benefitCard2 from "../assests/HPE/enterpriseone/smb-b/benefits-2.svg";
import benefitCard3 from "../assests/HPE/enterpriseone/smb-b/benefits-3.svg";
import StatsCard from "../components/ui/enterprise1/StatsCard";
import EnterpriseInput from "../components/ui/enterprise1/EnterpriseInput";
import { useState } from "react";
import EnterpriseHeader from "../components/ui/enterprise1/EnterpriseHeader";
import ZertoHighlightCard from "../components/ui/zerto/ZertoHighlightCard";
import ZertoFeatureCard from "../components/ui/zerto/ZertoFeatureCard";
import BeforeAfterCard from "../components/ui/zerto/BeforeAfterCard";
import ZertoResourcesForm from "../components/ui/zerto/ZertoResoucesForm";
import ZertoStackedDocuments from "../components/ui/zerto/ZertoStckedDocument";
import EnterpriseFooter from "../components/ui/enterprise1/EnterpriseFooter";
import Layout from "../components/layout/Layout";
import { useTrackEvent } from "../hooks/useTrackEvent";
const ZertoTwo = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [fullName, setFullName] = useState("");
  const [fullNameError, setFullNameError] = useState(false);
  const trackEvent = useTrackEvent();

  const handleFullNameFocus = () => {
    trackEvent(
      {
        event: "form_start",
        form_location: "hero",
        statsig_design_id: "zerto-2",
      },
      { once: true },
    );
  };

  function handleOpenPopup() {
    if (!fullName.trim()) {
      setFullNameError(true);
      return;
    }
    setFullNameError(false);
    setShowPopup(true);
    trackEvent(
      {
        event: "form_continue",
        form_location: "hero",
        statsig_design_id: "zerto-2",
      },
      { once: true },
    );
  }

  const beforeData = [
    {
      value: "12 hours",
      description: "of potential data loss",
    },
    {
      value: "2 weeks",
      description: "to full recovery",
    },
  ];
  const afterData = [
    {
      value: "10 seconds",
      description: "of data loss",
    },
    {
      value: "<10 min",
      description: "to full recovery",
    },
  ];
  return (
    <Layout title="HPE Zerto Software" variant="enterprise">
      <div className="w-full min-h-screen ">
        {/** 1 */}
        <div className="w-full bg-green-04 pb-24">
          <div className="flex flex-col max-w-[1188px] px-4 sm:px-6 md:px-10 mx-auto md:flex-row gap-6 md:gap-10 ">
            {/* LEFT SECTION */}
            <div className="flex flex-col gap-10 md:gap-16 w-full lg:w-1/2 lg:min-w-[450px]">
              {/* TEXT (TOP) */}
              <div className="order-1 md:order-none flex flex-col gap-6 md:max-w-[450px] font-google">
                <p className=" text-grey-02 font-medium text-[22px]/[28px]  md:text-[36px]/[44px] self-stretch">
                  Under 60 seconds. Near zero data loss.
                  <span className="text-blue">
                    {" "}
                    Three tools replaced by one.
                  </span>
                </p>

                <p className="text-grey-04 md:text-4/6 text-3/[18px] font-inter">
                  <b className="text-grey-03 font-semibold">HPE Zerto</b>{" "}
                  replaces separate DR, backup and ransomware detection tools
                  with a single continuous data protection platform built for
                  businesses managing lean IT teams.
                </p>
              </div>

              {/* IMAGE (MOBILE ONLY - BETWEEN) */}
              <div className="order-2 md:hidden w-full flex">
                <div className="relative w-full md:max-w-[553px]">
                  <img
                    src={masthead}
                    alt=""
                    className="w-full h-auto rounded-[8px]"
                  />
                </div>
              </div>

              {/* FORM (BOTTOM) */}
              <div className="order-3 md:order-none flex w-full md:min-w-[400px] md:max-w-[400px] flex-col gap-6">
                {/* STEP */}
                <span className="text-white py-0.5 px-3 rounded-3xl font-google bg-navy-blue-03 w-fit text-2/[22px] font-medium">
                  STEP 1 / 2
                </span>

                {/* INPUT */}
                <div className="flex flex-col gap-4">
                  <div className="flex gap-4">
                    <div className="flex-1 flex flex-col gap-1">
                      <EnterpriseInput
                        placeholder="Full name*"
                        theme="zerto"
                        variant="dark"
                        className="flex-1"
                        icon={userIcon}
                        inputClassName="text-white text-[14px]/[22px] font-medium h-[46px]"
                        iconClassName="w-5 h-5"
                        value={fullName}
                        onFocus={handleFullNameFocus}
                        onChange={(e) => {
                          setFullName(e.target.value);
                          if (e.target.value.trim()) {
                            setFullNameError(false);
                          }
                        }}
                        error={
                          fullNameError ? "Please enter your full name" : ""
                        }
                      />
                    </div>

                    <div
                      onClick={handleOpenPopup}
                      className="flex h-[46px] px-4 rounded-lg bg-blue hover:bg-blue-01 active:bg-blue-02 items-center justify-center cursor-pointer"
                    >
                      <img
                        src={arrowRightIcon}
                        className="w-[18px] h-[18px]"
                        alt=""
                      />
                    </div>
                  </div>

                  {/* INFO */}
                  <div className="flex items-center gap-2">
                    <img src={clockIcon} className="w-[14px] h-[14px]" alt="" />
                    <p className="text-grey-03 font-normal text-[10px]/[18px] md:text-[12px]/[20px] font-inter">
                      <span className="text-green font-medium">
                        Takes 30 seconds.
                      </span>{" "}
                      Resource pack downloads instantly after.
                    </p>
                  </div>
                </div>

                {/* DIVIDER */}
                <div className="w-full h-[1px] border-white/10 border-dashed border-t" />

                <ZertoStackedDocuments />

                {/* <DocumentPreview/> */}
              </div>
            </div>

            {/* RIGHT IMAGE (DESKTOP ONLY) */}
            <div className="hidden md:flex w-full md:w-[553px] justify-end">
              <div className="relative w-full max-w-[553px]">
                <img
                  src={masthead}
                  alt=""
                  className="w-full h-auto rounded-[8px]"
                />
              </div>
            </div>
          </div>
        </div>
        {/** 2 */}
        <div className="max-w-full bg-green-03">
          <div
            className="
                flex flex-col md:flex-row max-w-[1188px]
                 mx-auto
                py-12 md:py-20
                px-4 sm:px-6 md:px-10
                gap-6 md:gap-10
                items-start md:items-center
                bg-green-03"
          >
            <StatsCard
              title="10s"
              description="Recovery time objective"
              image={number1}
            />
            <div className="w-full h-[1px] md:w-[1px] md:h-[18px] opacity-[0.08] bg-white" />

            <StatsCard
              title="<10m"
              description="Data loss with continuous replication"
              image={number2}
            />
            <div className="w-full h-[1px] md:w-[1px] md:h-[18px] opacity-[0.08] bg-white" />

            <StatsCard
              title="59%"
              description="DR, backup and ransomware in one platform"
              image={number3}
            />
          </div>
        </div>
        {/* </div> */}
        {/** 3 */}
        {/* <div className="flex flex-col justify-center items-center container mx-auto w-full gap-[80px] mt-[120px]  m-auto mb-[80px]"> */}
        <div className="w-full max-w-[1188px] mx-auto md:mt-[120px] mt-20 mb-[80px] px-4 sm:px-6 md:px-10 flex flex-col gap-[80px]">
          <div className="">
            <p className="text-grey-06 text-[20px] leading-[32px] font-google text-start md:text-[32px] font-style:normal md:leading-[48px] font-medium">
              Most businesses are{" "}
              <span className="text-red">paying for three </span>separate tools
              for disaster recovery, backup and ransomware detection.{" "}
              <span className="text-red">
                Three vendors, three costs, and three gaps
              </span>{" "}
              between systems that a well-timed attack can exploit.
              <span className="text-blue"> Zerto closes all three gaps</span> in
              one platform without adding complexity for your team.
            </p>
          </div>
          <div className="flex flex-col items-start gap-12 md:inline-flex md:w-auto md:flex-row md:items-center md:gap-6">
            <ZertoHighlightCard
              badge="CAPABILITY"
              image={zertoMaster}
              // title="Stop paying VMware tax"
              // description="Run VMware and KVM side by side on existing infrastructure. No forced migration. Per-socket pricing at a fraction of Broadcom charges."
            />
          </div>
          <div className="flex flex-col md:flex-row md:items-start w-full items-start gap-6">
            <ZertoFeatureCard
              image={benefitCard1}
              title="One platform not three"
              description="DR, backup and ransomware protection from a single interface. Fewer vendors, lower cost, no gaps between tools attackers can exploit."
            />
            <ZertoFeatureCard
              image={benefitCard2}
              title="Recovery in under 60 seconds"
              description="Continuous journal replication means recovery point is always seconds old. Encryption detected and rolled back automatically before damage spreads."
            />
            <ZertoFeatureCard
              image={benefitCard3}
              title="Built for lean IT teams"
              description="Agentless architecture. No agents to install. No manual intervention during recovery. Attackers cannot disable protection by targeting agent processes."
            />
          </div>

          <div className="w-full">
            {/* <div className="flex flex-col md:flex-row rounded-[16px] overflow-hidden">

          </div> */}
            <div className="w-full">
              <div className="flex flex-col md:flex-row rounded-[16px] overflow-hidden">
                {/* BEFORE */}
                <BeforeAfterCard
                  label="TENCATE"
                  title="BEFORE ZERTO"
                  items={beforeData}
                  variant="before"
                />

                {/* AFTER */}
                <BeforeAfterCard
                  title="AFTER ZERTO"
                  items={afterData}
                  variant="after"
                />
              </div>
            </div>
          </div>
        </div>
        {/** 4 */}
        <ZertoResourcesForm
          showPreview={true}
          isPopup={false}
          showQuestionGroupOne={false}
          showQuestionGroupTwo={true}
          formLocation="bottom"
          statsigDesignId="zerto-2"
        />
        {showPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div
              className="absolute inset-0 bg-black/80"
              onClick={() => setShowPopup(false)}
            />

            <div className="relative w-full max-w-[1100px] z-10 max-h-[90vh] overflow-y-auto">
              <ZertoResourcesForm
                showPreview={true}
                isPopup={true}
                onClose={() => setShowPopup(false)}
                initialFullName={fullName}
                showQuestionGroupOne={false}
                showQuestionGroupTwo={true}
                formLocation="hero"
                statsigDesignId="zerto-2"
              />
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};
export default ZertoTwo;
